import { useEffect } from 'react';
import { Table, useFilters } from '@ui/src';
import formatCardTransacationList from '../../../hoc/customers/helpers/format-card-transaction';
import { CardsTransactions } from '../../../hoc/customers/types';
import {
  overviewCardsColumnsLabels,
  overviewCardsFiltersSchema,
  overviewCardsColumns,
} from '../../../hoc/individual/variables/overview-cards';
import { OverviewStatementsCardsTransactionTypes } from './types';

import cn from './overview-statements.module.css';

const OverviewStatementsCardsTransaction = ({
  onSort,
  onFilter,
  cardsTransactions,
  filters,
  sort,
  requestInProgress,
}: OverviewStatementsCardsTransactionTypes): React.JSX.Element => {
  const { filtersComponent, handleSubmit, reset } = useFilters({
    filtersSchema: overviewCardsFiltersSchema,
    filters,
    onFilterChange: onFilter,
  });

  useEffect(() => {
    reset(filters);
  }, [filters, reset]);

  return (
    <Table
      columns={overviewCardsColumns}
      data={
        formatCardTransacationList(cardsTransactions as CardsTransactions[]) ||
        []
      }
      onSort={(name) => onSort(name)}
      filters={filters}
      sort={sort}
      columnsLabels={overviewCardsColumnsLabels}
      onFilterChange={(values) => onFilter(values)}
      filtersComponent={filtersComponent}
      handleSubmit={handleSubmit}
      isLoading={requestInProgress}
      tableFormClassName={cn.overviewStatementsTableForm}
      tableHeadCellClassName={cn.overviewStatementsTableHeadCell}
    />
  );
};

export default OverviewStatementsCardsTransaction;
